import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { categoryLabel, competitionsLabel, daysLabel, monthLabel, organizerLabel, placeLabel } from "./plannerLabels"
import { openWarnings } from "./plannerItems"
import ItemState from "./ItemState"

const PAGE_SIZE = 50
const COLUMNS = ["Dates", "Number · Name", "Category", "City · Club", "Organizer", "Competitions", "State", "Warnings"]

// The List view (ticket 15): the tournaments of the view by start date, a month per group, 50 a page. Ended tournaments are
// hidden and counted (story 7). A row opens the proposal in the editor, or the published event's page. Another view (`viewKey`)
// starts on the first page; a reread of the same view keeps the page. A proposal can be selected (`selected` by id, `onSelect`), to
// send it to its organizer (C3 pinned decision Q2).
export default function PlannerList({ items, hiddenEnded, settings, timeZone, onOpen, viewKey, selected = {}, onSelect }) {
  const [page, setPage] = useState(0)
  useEffect(() => setPage(0), [viewKey])
  useEffect(() => { if (page * PAGE_SIZE >= items.length && page > 0) setPage(Math.max(0, Math.ceil(items.length / PAGE_SIZE) - 1)) }, [items.length, page])
  const shown = items.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE)
  const months = []
  shown.forEach(item => {
    const month = monthLabel(item.days.start)
    if (months[months.length - 1]?.month !== month) months.push({ month, items: [] })
    months[months.length - 1].items.push(item)
  })
  const range = items.length ? `${page * PAGE_SIZE + 1}–${Math.min(items.length, (page + 1) * PAGE_SIZE)} of ${items.length}` : "No tournaments"
  return <section className="ep-list" aria-label="Tournaments">
    <div role="table" aria-label="Tournaments">
      <div role="rowgroup"><div role="row" className="ep-list-row ep-list-head">
        {COLUMNS.map(column => <span role="columnheader" key={column}>{column}</span>)}
      </div></div>
      {months.map(({ month, items: monthItems }) => <div role="rowgroup" key={month}>
        <div role="row" className="ep-list-month"><span role="cell"><h3>{month}</h3></span></div>
        {monthItems.map(item => <div role="row" className="ep-list-row" key={item.key}>
          <span role="cell" className="ep-nowrap" data-label="Dates">{daysLabel(item.days)}</span>
          <span role="cell" data-label="Number · Name" className="ep-stack">
            {item.kind === "event"
              ? <Link className="ep-link" to={`/events/${item.id}`} aria-label={`Open ${item.label}`}>{item.label}</Link>
              : <span className="ep-inline">
                {onSelect && <input type="checkbox" aria-label={`Select ${item.label}`} checked={Boolean(selected[item.id])} onChange={() => onSelect(item)} />}
                <button type="button" className="ep-link" onClick={() => onOpen(item)} aria-label={`Open ${item.label}`}>{item.label}</button></span>}
            <span className="ep-meta">{item.name || "No name yet"}</span>
          </span>
          <span role="cell" data-label="Category"><span className={`ep-dot ep-cat-${item.category}`} aria-hidden="true" />{categoryLabel(settings, item.category)}</span>
          <span role="cell" data-label="City · Club" className="ep-stack">
            <span>{placeLabel(item)}</span>
            {item.region && <span className="ep-meta">{item.region}</span>}
          </span>
          <span role="cell" data-label="Organizer">{organizerLabel(item.organizer)}</span>
          <span role="cell" data-label="Competitions" className="ep-tiles">{competitionsLabel(item.competitions) || "—"}</span>
          <span role="cell" data-label="State"><ItemState item={item} timeZone={timeZone} /></span>
          <span role="cell" data-label="Warnings" className="ep-warn-count">{item.kind === "proposal" && openWarnings(item).length
            ? <span aria-label={`${openWarnings(item).length} warnings`}>{openWarnings(item).length}</span> : ""}</span>
        </div>)}
      </div>)}
    </div>
    <div className="ep-list-foot">
      <span className="ep-meta">{range}{hiddenEnded ? ` · ${hiddenEnded} ended ${hiddenEnded === 1 ? "tournament" : "tournaments"} hidden` : ""}</span>
      {items.length > PAGE_SIZE && <span className="ep-pager">
        <button type="button" className="btn btn-light btn-sm" disabled={page === 0} onClick={() => setPage(page - 1)}>Previous</button>
        <button type="button" className="btn btn-light btn-sm" disabled={(page + 1) * PAGE_SIZE >= items.length} onClick={() => setPage(page + 1)}>Next</button>
      </span>}
    </div>
  </section>
}
